import React, { useContext } from 'react';
import { OrganizationsContext } from '../../OrganizationContextProvider';
import { useParams, generatePath } from 'react-router-dom';
import { useNavigate } from 'src/utils/useNavigate';
import Text from 'src/components/Text';
import Button from 'src/components/Button';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

type Props = {
  error?: boolean;
}

const Empty: React.FC<Props> = ({ error }) => {
  const navigate = useNavigate();
  const { organizationUeid } = useParams();
  const { currentOrganization } = useContext(OrganizationsContext);
  
  const handleAddBankClick = () => {
    navigate(generatePath(routes.addBank, { organizationUeid }), {
      state: { organization: currentOrganization },
    });
  }
  
  if (error) {
    return (
      <div className={styles['placeholder']}>Произошла ошибка при загрузке банков</div>
    )
  }

  return (
    <div className={styles['placeholder']}>
      <Text type="p" muted>Для организации ещё не были добавлены банки.</Text>
      <Button onClick={handleAddBankClick} className={styles['add-bank-button']}>
        Добавить банк
      </Button>
    </div>
  );
};

export default Empty;
